import type {BioIconProps} from '../../icons/common-types'
import {FlagIconByLocale} from '../../icons/flag-icons-by-locale'

export default function TopExpertsChoiceLogo({locale, ...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-2 text-2xl font-semibold text-white tablet:gap-1 tablet:text-base">
      <svg {...attributes} width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1107_8579)">
          <g clipPath="url(#clip1_1107_8579)">
            <path
              d="M31.1668 19.0164L30.9976 23.2844L14.4534 26.1325L8.30288 18.5837L8.18555 14.4563L14.4916 21.4344L31.1668 19.0164Z"
              fill="white"
            />
            <path d="M14.789 21.0868L36.0212 17.9547L22.8442 6.13257L3.27112 8.60901L14.789 21.0868Z" fill="white" />
            <path
              d="M4.477 19.2839L5.13735 21.2613H7.27393C7.49223 21.2613 7.58501 21.5347 7.40764 21.6594L5.67763 22.8804L6.33798 24.8579C6.4062 25.0596 6.16607 25.2295 5.98871 25.1047L4.2587 23.8837L2.52869 25.1047C2.35132 25.2295 2.11392 25.0622 2.17941 24.8579L2.83976 22.8804L1.11521 21.6594C0.937846 21.5347 1.02789 21.2613 1.24892 21.2613H3.38551L4.04586 19.2839C4.11408 19.0821 4.40878 19.0821 4.477 19.2839Z"
              fill="white"
            />
            <line x1="4.27124" y1="9.13257" x2="4.27124" y2="20.1326" stroke="white" strokeWidth="0.5" />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1107_8579">
            <rect width="36" height="36" fill="white" transform="translate(0.0212402 0.132568)" />
          </clipPath>
          <clipPath id="clip1_1107_8579">
            <rect width="36" height="20" fill="white" transform="translate(0.0212402 6.13257)" />
          </clipPath>
        </defs>
      </svg>
      <span>Top Experts Choice</span>
      <FlagIconByLocale
        locale={locale}
        className="absolute -right-6 -top-2 size-7 shrink-0 -rotate-12 tablet:-right-4 tablet:-top-1 tablet:size-5"
      />
    </div>
  )
}
